module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/life-is-good-93555510833cfbb896c1c4a49136d8b3.svg";